// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"e7c1664e","78":"7620e34a","204":"40c3d7eb","255":"d3365028","296":"89d00177","357":"a49caf7e","673":"56474279"}[chunkId] + ".chunk.css";
};